var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"boxBorder",style:({ width: _vm.width, height: _vm.height, margin: _vm.margin, ..._vm.boxStyle })},[_c('div',{staticClass:"boxBorder_box",style:({ padding: _vm.padding })},[_c('div',{ref:"contentDiv",class:_vm.childBoxClass,style:({
        'z-index': 2,
        position: 'relative',
        width: '100%',
        height: '100%',
        'box-sizing': 'border-box',
        'grid-template-columns': `repeat(${_vm.gridStyle.columnQuantity}, 1fr)`,
        'grid-template-rows': `repeat(${_vm.gridStyle.rowQuantity}, 1fr)`,
        'grid-row-gap': _vm.gridStyle.rowGap,
        'grid-column-gap': _vm.gridStyle.columnGap,
        ..._vm.childBoxStyle})},[_vm._t("default")],2)]),(_vm.spanShow)?_c('span',{staticClass:"leftTop"}):_vm._e(),(_vm.spanShow)?_c('span',{staticClass:"rightTop"}):_vm._e(),(_vm.spanShow)?_c('span',{staticClass:"leftBottom"}):_vm._e(),(_vm.spanShow)?_c('span',{staticClass:"rightBottom"}):_vm._e(),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.titleShow),expression:"titleShow"}],staticClass:"topText",style:(_vm.titleStyle),on:{"click":_vm.setVnodeCom}},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }